import React from 'react';
import {ThemeProvider, StyleReset} from 'atomize';
import theme from './Theme/Theme'
import {Route, Switch, Router} from 'react-router-dom';
import Routes from './Routes';
import {createGlobalStyle} from 'styled-components';
import Collector from './Components/Molecules/Collector';
// import ScrollToTop from './utils/scrollToTop/scrollToTop';
import './App.css';
import Sidebar from "react-sidebar";
import {sideBarStyles} from "./Components/Molecules/SideBar/styles";
import CollectorConatiner from "./Components/Molecules/Collector/collectorContainer";
import {Provider} from 'react-redux';
import Footer from "./Components/Molecules/Footer"
import store from './redux/store';
import Menu from "./Components/Molecules/Menu";
import { createBrowserHistory } from "history";
import { wrapHistory } from "oaf-react-router";

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

const settings = {
  disableAutoScrollRestoration: false,
  announcePageNavigation: true,
  shouldHandleAction: (previousLocation, nextLocation) => {
    const wasOnActivitiePage = previousLocation.pathname.includes('/activities') && !previousLocation.pathname.includes('/activities/');
    const isStillOnActivitiesPage = nextLocation.pathname.includes('/activities') && !nextLocation.pathname.includes('/activities/');
    if (wasOnActivitiePage && isStillOnActivitiesPage) {
      return false;
    }
    const wasOnVideosPage = previousLocation.pathname.includes('/videos');
    const isStillOnVideosPage = nextLocation.pathname.includes('/videos');
    if (wasOnVideosPage && isStillOnVideosPage) {
      return false;
    }
    else {
      return true
    }
  },
  setPageTitle: false,
  handleHashFragment: true,
  restorePageStateOnPop: true,
  smoothScroll: false,
};


wrapHistory(history, settings);


const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Inter', sans-serif !important;
  }
  html {
    scroll-behavior: smooth;
  }
`;

function App(props) {
  const [collectorOpen, setCollectorOpen] = React.useState(false);

  return (
    <div id={"main"}>
      <Provider store={store}>
        <ThemeProvider
          theme={theme}
        />
        <StyleReset/>
        <GlobalStyle/>
        <Router history={history} basename={'/e4h'}>
          <Collector
            action={() => setCollectorOpen(!collectorOpen)}
          />
          <Menu/>
          <div
            id={"main-container"}
            style={{pointerEvents: collectorOpen ? 'none' : 'auto'}}
          >
            <Switch>
              {Routes.map(route => <Route key={`route-${route.name}`} {...route} />)}
            </Switch>
          </div>
          <Footer/>
          <Sidebar
            sidebar={<CollectorConatiner
              close={() => setCollectorOpen(false)}
            />}
            open={collectorOpen}
            pullRight={true}
            styles={sideBarStyles(collectorOpen)}
            shadow={false}
          >
            <></>
          </Sidebar>
        </Router>
      </Provider>
    </div>
  );
}

export default App;
